import { gql } from '@apollo/client';

/**
 * Mints a short-lived (~60s), single-audience ticket for the QuickSight embed
 * BFF (ST-330 / ST-332). The gateway forwards to the Security MS signing
 * endpoint; the BFF then verifies the ticket locally.
 *
 * Authenticated by the `backend_jwt` cookie the Apollo client already sends via
 * `credentials: 'include'`, same as every other operation.
 *
 * Rate-limited gateway-side to 10 calls per user per 60s, so request one per
 * embed — the embed URL it unlocks is valid for ~15 minutes.
 */
export const MUTATION_ISSUE_EMBED_TICKET = gql`
    mutation IssueEmbedTicket($audience: String!) {
        issueEmbedTicket(audience: $audience) {
            ticket
            ttl
        }
    }
`;

export const MUTATION_SET_MY_DASHBOARD_PREFERENCE = gql`
    mutation Mutation($data: SetMyDashboardPreferenceInput!) {
        setMyDashboardPreference(data: $data) {
            createdAt
            tag
            updatedAt
            dashboard {
                createdAt
                dashboardId
                enabled
                embedType
                expirationTime
                id
                serverUrl
                siteIdentifier
                updatedAt
                environment
            }
        }
    }
`;
